import { useEffect } from "react";

import AppRoutes from "./app.routes";
import AuthRoutes from "./auth.routes";
import { useUserStore } from "@/store";

const RoutesProvider = () => {
  const { isAuthenticated, restoreSession, authLoading } = useUserStore();

  useEffect(() => {
    restoreSession();
  }, []);

  return !authLoading ? <div>{isAuthenticated ? <AppRoutes /> : <AuthRoutes />}</div> : null;
};

export default RoutesProvider;
